// extracted by mini-css-extract-plugin
module.exports = {"event__header":"event__header__hZ9xx","event__header__avatar":"event__header__avatar__1d_2W","event__header__title":"event__header__title__2HJvD","error":"error__20vQk"};